import { render, staticRenderFns } from "./ProjectFilter.vue?vue&type=template&id=3552157c&scoped=true&"
import script from "./ProjectFilter.vue?vue&type=script&lang=ts&"
export * from "./ProjectFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552157c",
  null
  
)

/* custom blocks */
import block0 from "./ProjectFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports